export * from "./layout/actions"

export const resetAll = () => ({ type: "RESET_ALL" });

// Authentication module
export * from "./auth/register/actions"
export * from "./auth/login/actions"
export * from "./auth/forgetpwd/actions"
export * from "./auth/profile/actions"

//Ecommerce
export * from "./e-commerce/actions"

//Calendar
export * from "./calendar/actions"

//chat
export * from "./chat/actions"

//crypto
export * from "./crypto/actions"

//invoices
export * from "./invoices/actions"

// projects
export * from "./projects/actions"

// tasks
export * from "./tasks/actions"

// contacts
export * from "./contacts/actions"

// contacts
export * from "./mails/actions"

//dashboard
export * from "./dashboard/actions";

//dashboard-saas
export * from "./dashboard-saas/actions";

//master

//holiday

export * from "./master/holiday/actions"

//roles
export * from "./master/role/actions"

//Login Creation
export * from "./configuration/logincreation/actions"

//Category
export * from "./master/category/actions"

//Unit
export * from "./master/unit/actions"

//leave

export * from "./master/leave/actions"

//department
export * from "./master/department/actions"
//shift

export * from "./master/shift/actions"

//shift group

export * from "./master/shiftgroup/actions"

//designation
export * from "./master/designation/actions"

//qualification
export * from "./master/qualification/actions"

//employee details
export * from "./employee/employeedetails/actions"

//employee exemption
export * from "./employee/exemption/actions"

//employee resignation
export * from "./employee/resignation/actions"

//employee circular
export * from "./employee/circular/actions"

//employee permission-policy
export * from "./employee/permission-policy/actions"

//employee multilevel-approval
export * from "./employee/multilevel-approval/actions"

//recruitment keys-responsibilities
export * from "./recruitment/keys-responsibilities/actions"

//recruitment qualification
export * from "./recruitment/qualification/actions"

//employee grace-policy
export * from "./employee/grace-policy/actions"

//reimbursement master
export * from "./reimbursement/master/actions"

//reimbursement reports
export * from "./reimbursement/Reports/actions"

//Payroll Setup Allowance
export * from "./payroll/setup/allowance/actions"
//Payroll Setup Allowance
export * from "./payroll/setup/mapping/actions"

//Payroll Setup Deduction
export * from "./payroll/setup/deduction/actions"

//reimbursement transactions
export * from "./reimbursement/transactions/actions"

//Payroll Setup Salary Scale
export * from "./payroll/setup/salary-scale/actions"

//Payroll Deduction Tax
export * from "./payroll/deduction/tax/actions"

//Payroll Deduction Fixed Deduction
export * from "./payroll/deduction/fixed-deduction/actions"

//Job setup Postion Creation and Skill Mapping
export * from "./recruitment/position/actions"

//Attendance > Time Deductions
export * from "./attendance/time-deductions/actions"

//Payroll Deduction Monthly Deduction
export * from "./payroll/deduction/monthly-deduction/actions"

//Timesheet Setup Service
export * from "./timesheet/setup/service/actions"

//Timesheet Setup Client
export * from "./timesheet/setup/client/actions"

//Timesheet Setup Project
export * from "./timesheet/setup/project/actions"

//Timesheet Setup Module
export * from "./timesheet/setup/module/actions"

//Timesheet Setup Task
export * from "./timesheet/setup/task/actions"

//Timesheet Setup Task Type
export * from "./timesheet/setup/task-type/actions"

//Payroll Salary Employee Salary Definition
export * from "./payroll/salary/salary-definition/actions"

//Attendance > Biometric
export * from "./attendance/biometric/actions"

//Payroll > Extra Payment
export * from "./payroll/salary/extra-payment/actions"

//Payroll > Allowance
export * from "./payroll/salary/allowance/actions"

//Payroll > Stop Payment
export * from "./payroll/salary/stoppayment/actions"

//Recruitment > Requisition
export * from "./recruitment/requistion/actions"

//Timesheet > Transactions > Apply
export * from "./timesheet/transactions/apply/actions"

//Timesheet > Transactions > Approval
export * from "./timesheet/transactions/approval/actions"

//Timesheet > Reports
export * from "./timesheet/reports/actions"

//Expenses master
export * from "./expenses/actions"

//Recruitment Onboarding
export * from "./recruitment/onboarding/actions"

//Attendance Extra Duty
export * from "./attendance/extra-duty/actions"

//Attendance Leave Management
export * from "./attendance/leave/actions"

//Employee Report
export * from "./report/employee/actions"

//Attendance Report
export * from "./report/attendance/actions"

//Skill Master
export * from "./master/skill/actions"

//Tripmaster
export * from "./master/tripmaster/actions"

//Bank Master
export * from "./master/bank/actions"

//Evaluation Master
export * from "./master/evaluation/actions"

//Score Master
export * from "./master/score/actions"

//Recruitment Resource Approval
export * from "./recruitment/resource-approval/actions"

//Payroll Reports
export * from "./payroll/reports/actions"